import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M16.8 21a4 4 0 0 1-.8 0 16.5 16.5 0 0 1-8.32-4.66A16.5 16.5 0 0 1 3.05 8a4 4 0 0 1 1-3.54l.66-.65a2.75 2.75 0 0 1 3.88 0L9.82 5a2.29 2.29 0 0 1-.09 3.27L8.91 9a11.7 11.7 0 0 0 2.48 3.57A11.9 11.9 0 0 0 15 15.1l.89-.92a2.27 2.27 0 0 1 3.19 0l1.17 1.18a2.73 2.73 0 0 1 0 3.88l-.65.66a3.9 3.9 0 0 1-2.8 1.1M6.7 4.48a1.24 1.24 0 0 0-.88.36l-.66.65a2.49 2.49 0 0 0-.64 2.2 15 15 0 0 0 4.26 7.54 14.87 14.87 0 0 0 7.53 4.25 2.49 2.49 0 0 0 2.2-.64l.65-.66a1.23 1.23 0 0 0 0-1.76L18 15.24a.79.79 0 0 0-1.07 0l-.9.91a1.53 1.53 0 0 1-1.66.32 13.4 13.4 0 0 1-4-2.8 13.4 13.4 0 0 1-2.8-4A1.52 1.52 0 0 1 7.85 8l.82-.82A.79.79 0 0 0 8.76 6L7.58 4.84a1.24 1.24 0 0 0-.88-.36" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }